import Hero from '../components/Hero';
import Pricing from '../components/Pricing';
import Team from '../components/Team';
import Faq from '../components/Faq';
import TrustpilotWidget from '../components/TrustpilotWidget';
import CoverageContactSection from '../components/CoverageContactSection';
import ClientSpaceSection from '../components/ClientSpaceSection';
import { Chatbot } from "../components/Chatbot";


const HomePage = () => (
  <>
    <Hero />
    <CoverageContactSection />
    <Pricing />
    <ClientSpaceSection />
    <Team />
    <TrustpilotWidget />
    <Faq />
    <Chatbot />

  </>
);

export default HomePage; 